import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) return <div className="py-24 text-center text-muted-foreground">Loading…</div>;
  if (!user || !user.email) return <Navigate to="/login" replace />;
  if (user.needs_profile && location.pathname !== "/complete-profile") return <Navigate to="/complete-profile" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
